import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable()
export class UtilsService {
    isMobileVersion(): boolean {
        const ua = navigator.userAgent;
        
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(ua)) {
            return true;
        }

        return false;
    }

    getAgeLabel(age: number): string {
        if (age < 20)
            return 'лет';
        let t = age % 10;

        if (t == 1)
            return 'год';

        if (t > 1 && t <5)
            return 'года';

        return 'лет';

    }

    formatDate(timestamp: number): string {
        let time = moment.unix(timestamp);

        return time.format("DD/MM/YYYY");
    }
}